<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1">
      <mat-card-title class="">Novo tarifário</mat-card-title>
    </div>
    <!--    <button-->
    <!--      mat-raised-button-->
    <!--      class="btn-add"-->
    <!--      (click)="createLocation()"-->
    <!--      matTooltip="Cadastrar localização"-->
    <!--    >-->
    <!--      <mat-icon>add</mat-icon>-->
    <!--      Localização-->
    <!--    </button>-->
    <button mat-flat-button class="btn-tg-cancel w-1/12" (click)="close()">Cancelar</button>
    <button mat-flat-button class="btn-tg w-1/12" [disabled]="!checkForm() || loading" (click)="createTariff()">
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Criar
      }
    </button>
  </mat-card-header>
  <div class="mt-4">
    <mat-accordion multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Tarifário</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div [formGroup]="form" class="mt-4 container mx-auto">
          <div class="flex justify-between items-center mt-3 -mx-2">
            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Tipo tarifário</mat-label>
              <mat-select formControlName="tariffType" (selectionChange)="onSelectionChangeTypeTarrif($event)">
                @for (type of listTypeTariff; track type) {
                  <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="input-tg w-9/12 px-2" appearance="outline">
              <mat-label>Cliente</mat-label>
              <input matInput formControlName="client" readonly />
              @if (this.form.get('client')!.enabled) {
                <button mat-icon-button matSuffix (click)="addClient()">
                  <mat-icon>add</mat-icon>
                </button>
              }
            </mat-form-field>
            <!--            <mat-slide-toggle-->
            <!--              class="input-tg w-1/12 p-bottom-toggle px-2"-->
            <!--              formControlName="active"-->
            <!--              >{{-->
            <!--                form.get('active')?.value ? 'Ativo' : 'Inativo'-->
            <!--              }}</mat-slide-toggle-->
          </div>

          <div class="flex justify-between items-center mt-3 -mx-2">
            <mat-form-field class="input-tg w-full px-2" appearance="outline">
              <mat-label>Fornecedor</mat-label>
              <input matInput formControlName="supplier" readonly />
              <button mat-icon-button matSuffix (click)="addSupplier()">
                <mat-icon>add</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="flex justify-between items-center mt-3 -mx-2">
            <mat-form-field appearance="outline" class="input-tg w-3/12 px-2">
              <mat-label>Origem</mat-label>

              <input matInput type="text" formControlName="origin" [matAutocomplete]="autoOrigin" />

              <mat-autocomplete #autoOrigin="matAutocomplete" [displayWith]="displayLocation" autoActiveFirstOption>
                <mat-option *ngFor="let opt of filteredOrigins | async" [value]="opt">
                  {{ opt.cidade }} - {{ opt.estado }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Destino</mat-label>
              <input matInput type="text" formControlName="destination" [matAutocomplete]="autoDestination" />

              <mat-autocomplete
                #autoDestination="matAutocomplete"
                [displayWith]="displayLocation"
                autoActiveFirstOption
              >
                <mat-option *ngFor="let opt of filteredDestinations | async" [value]="opt">
                  {{ opt.cidade }} - {{ opt.estado }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-slide-toggle class="input-tg w-6/12 p-bottom-toggle px-2" formControlName="urbanPerimeter"
              >Perimetro urbano:
              <strong>{{ form.get('urbanPerimeter')?.value ? 'dentro' : 'fora' }}</strong></mat-slide-toggle
            >
            <!--            <mat-slide-toggle-->
            <!--              class="input-tg w-3/12 p-bottom-toggle px-2"-->
            <!--              formControlName="standard"-->
            <!--              >Standard:-->
            <!--              <strong>{{-->
            <!--                form.get('standard')?.value ? 'sim' : 'não'-->
            <!--              }}</strong></mat-slide-toggle-->
            <!--            >-->
          </div>

          <div class="flex justify-between items-center mt-3 -mx-2">
            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Tipo Serviço</mat-label>
              <mat-select
                formControlName="serviceType"
                (selectionChange)="onSelectionChangeServiceSpecification($event)"
              >
                @for (type of listTypeService; track type) {
                  <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Serviço</mat-label>
              <mat-select formControlName="specificationService" (selectionChange)="onSelectionChangeService($event)">
                @if (listServiceSpecification.length == 0) {
                  <mat-option disabled>Nenhum registro.</mat-option>
                } @else {
                  @for (type of listServiceSpecification; track type) {
                    <mat-option [value]="type">{{ type.descricao }}</mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Tipo veículo</mat-label>
              <mat-select formControlName="vehicleType">
                @for (type of listTypeVehicle; track type) {
                  <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Tipo motorista</mat-label>
              <mat-select formControlName="driverType">
                @for (type of listTypeDriver; track type) {
                  <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="flex justify-between items-center mt-3 -mx-2">
            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Valor custo</mat-label>
              @if (form.get('cost')!.value != '') {
                <span matTextPrefix>R$&nbsp;</span>
              }
              <input matInput formControlName="cost" currencyInput />
            </mat-form-field>

            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Custo hora extra</mat-label>
              @if (form.get('costOvertime')!.value != '') {
                <span matTextPrefix>R$&nbsp;</span>
              }
              <input matInput formControlName="costOvertime" currencyInput />
            </mat-form-field>

            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Custo Km extra</mat-label>
              @if (form.get('costKmExtra')!.value != '') {
                <span matTextPrefix>R$&nbsp;</span>
              }
              <input matInput formControlName="costKmExtra" currencyInput />
            </mat-form-field>

            <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
              <mat-label>Validade</mat-label>
              <input
                matInput
                [matDatepicker]="validity"
                (focus)="openDatepicker()"
                formControlName="validity"
                readonly
              />
              <mat-datepicker-toggle matIconSuffix [for]="validity"></mat-datepicker-toggle>
              <mat-datepicker #validity></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Paradas do itinerário <span class="text-xs text-gray-500 ml-2">(opcional)</span></h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="container mx-auto mt-2">
          <parada-itinerario-editor
            [paradas]="paradas"
            [location]="editorLocation"
            (paradasChange)="onParadasChange($event)"
          />
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="itemsList.length > 0" [disabled]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Lista Tarifarios</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="container mx-auto">
          <div [formGroup]="formAverage" class="mt-4 container mx-auto" [hidden]="itemsList.length == 0">
            <div class="flex justify-end items-center mt-3 -mx-2">
              <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
                <mat-label>Média Custo</mat-label>
                @if (formAverage.get('averageCost')!.value != '') {
                  <span matTextPrefix>R$&nbsp;</span>
                }
                <input matInput formControlName="averageCost" currencyInput readonly />
              </mat-form-field>

              <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
                <mat-label>Média hora extra</mat-label>
                @if (formAverage.get('averageOvertime')!.value != '') {
                  <span matTextPrefix>R$&nbsp;</span>
                }
                <input matInput formControlName="averageOvertime" currencyInput readonly />
              </mat-form-field>

              <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
                <mat-label>Média Km extra</mat-label>
                @if (formAverage.get('averageKmExtra')!.value != '') {
                  <span matTextPrefix>R$&nbsp;</span>
                }
                <input matInput formControlName="averageKmExtra" currencyInput readonly />
              </mat-form-field>
            </div>
          </div>
          @if (!loadingTable) {
            <div>
              <table-list-tariff [dataSource]="itemsList" [columns]="columns" />
            </div>
            <div>
              @if (itemsList.length > 0) {
                <pagination
                  [currentPage]="page"
                  [pageSize]="rows"
                  [totalRecords]="numberRows"
                  (pageChanged)="pageChanged($event)"
                />
              }
            </div>
          } @else {
            <div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
          }
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-card>
